
class AuthenticationError extends Error {
    constructor() {
        super("Authentication failed, if this error persists please contact support");
        this.name = "AuthenticationError";
    }
}

export default AuthenticationError;
